// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/ethnicity.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/ethnicity.proto.
 */
export const file_general_ethnicity: GenFile = /*@__PURE__*/
  fileDesc("ChdnZW5lcmFsL2V0aG5pY2l0eS5wcm90bxIOcHJvdG9zLmdlbmVyYWwqyQYKCUV0aG5pY2l0eRIVChFFVEhOSUNJVFlfVU5LTk9XThAAEhIKDkVUSE5JQ0lUWV9BUkFCEAESGQoVRVRITklDSVRZX0FTSUFOX09USEVSEAISGwoXRVRITklDSVRZX0FTSUFOX0NISU5FU0UQAxIaChZFVEhOSUNJVFlfQVNJQU5fS09SRUFOEAQSHAoYRVRITklDSVRZX0FTSUFOX0pBUEFORVNFEAUSGAoURVRITklDSVRZX0FTSUFOX1RIQUkQBhIoCiRFVEhOSUNJVFlfSU5ESUdFTk9VU19DRU5UUkFMX0FNRVJJQ0EQBxIsCihFVEhOSUNJVFlfSU5ESUdFTk9VU19OT1JUSF9BTUVSSUNBX0lOVUlUEAgSLAooRVRITklDSVRZX0lORElHRU5PVVNfTk9SVEhfQU1FUklDQV9NRVRJUxAJEjQKMEVUSE5JQ0lUWV9JTkRJR0VOT1VTX05PUlRIX0FNRVJJQ0FfRklSU1RfTkFUSU9OUxAKEiYKIkVUSE5JQ0lUWV9JTkRJR0VOT1VTX1NPVVRIX0FNRVJJQ0EQCxIeChpFVEhOSUNJVFlfSU5ESUdFTk9VU19PVEhFUhAMEhYKEkVUSE5JQ0lUWV9FVVJBU0lBThANEh4KGkVUSE5JQ0lUWV9FQVNURVJOX0VVUk9QRUFOEA4SFAoQRVRITklDSVRZX0lORElBThAPEhwKGEVUSE5JQ0lUWV9MQVRJTl9BTUVSSUNBThAQEiQKIEVUSE5JQ0lUWV9TT1VUSEVSTl9NRURJVEVSUkFORUFOEBESGAoURVRITklDSVRZX01JWEVEX1JBQ0UQEhIcChhFVEhOSUNJVFlfTUlERExFX0VBU1RFUk4QExIbChdFVEhOSUNJVFlfQkxBQ0tfQUZSSUNBThAUEhkKFUVUSE5JQ0lUWV9CTEFDS19PVEhFUhAVEicKI0VUSE5JQ0lUWV9CTEFDS19DQVJJQkJFQU5fQU5USUxMRUFOEBYSIgoeRVRITklDSVRZX1dISVRFX05PUlRIX0FNRVJJQ0FOEBcSFgoSRVRITklDSVRZX09DRUFOSUFOEBgSGgoWRVRITklDSVRZX1NDQU5ESU5BVklBThAZYgZwcm90bzM");

/**
 * @generated from enum protos.general.Ethnicity
 */
export enum Ethnicity {
  /**
   * @generated from enum value: ETHNICITY_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ETHNICITY_ARAB = 1;
   */
  ARAB = 1,

  /**
   * @generated from enum value: ETHNICITY_ASIAN_OTHER = 2;
   */
  ASIAN_OTHER = 2,

  /**
   * @generated from enum value: ETHNICITY_ASIAN_CHINESE = 3;
   */
  ASIAN_CHINESE = 3,

  /**
   * @generated from enum value: ETHNICITY_ASIAN_KOREAN = 4;
   */
  ASIAN_KOREAN = 4,

  /**
   * @generated from enum value: ETHNICITY_ASIAN_JAPANESE = 5;
   */
  ASIAN_JAPANESE = 5,

  /**
   * @generated from enum value: ETHNICITY_ASIAN_THAI = 6;
   */
  ASIAN_THAI = 6,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_CENTRAL_AMERICA = 7;
   */
  INDIGENOUS_CENTRAL_AMERICA = 7,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_NORTH_AMERICA_INUIT = 8;
   */
  INDIGENOUS_NORTH_AMERICA_INUIT = 8,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_NORTH_AMERICA_METIS = 9;
   */
  INDIGENOUS_NORTH_AMERICA_METIS = 9,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_NORTH_AMERICA_FIRST_NATIONS = 10;
   */
  INDIGENOUS_NORTH_AMERICA_FIRST_NATIONS = 10,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_SOUTH_AMERICA = 11;
   */
  INDIGENOUS_SOUTH_AMERICA = 11,

  /**
   * @generated from enum value: ETHNICITY_INDIGENOUS_OTHER = 12;
   */
  INDIGENOUS_OTHER = 12,

  /**
   * @generated from enum value: ETHNICITY_EURASIAN = 13;
   */
  EURASIAN = 13,

  /**
   * @generated from enum value: ETHNICITY_EASTERN_EUROPEAN = 14;
   */
  EASTERN_EUROPEAN = 14,

  /**
   * @generated from enum value: ETHNICITY_INDIAN = 15;
   */
  INDIAN = 15,

  /**
   * @generated from enum value: ETHNICITY_LATIN_AMERICAN = 16;
   */
  LATIN_AMERICAN = 16,

  /**
   * @generated from enum value: ETHNICITY_SOUTHERN_MEDITERRANEAN = 17;
   */
  SOUTHERN_MEDITERRANEAN = 17,

  /**
   * @generated from enum value: ETHNICITY_MIXED_RACE = 18;
   */
  MIXED_RACE = 18,

  /**
   * @generated from enum value: ETHNICITY_MIDDLE_EASTERN = 19;
   */
  MIDDLE_EASTERN = 19,

  /**
   * @generated from enum value: ETHNICITY_BLACK_AFRICAN = 20;
   */
  BLACK_AFRICAN = 20,

  /**
   * @generated from enum value: ETHNICITY_BLACK_OTHER = 21;
   */
  BLACK_OTHER = 21,

  /**
   * @generated from enum value: ETHNICITY_BLACK_CARIBBEAN_ANTILLEAN = 22;
   */
  BLACK_CARIBBEAN_ANTILLEAN = 22,

  /**
   * @generated from enum value: ETHNICITY_WHITE_NORTH_AMERICAN = 23;
   */
  WHITE_NORTH_AMERICAN = 23,

  /**
   * @generated from enum value: ETHNICITY_OCEANIAN = 24;
   */
  OCEANIAN = 24,

  /**
   * @generated from enum value: ETHNICITY_SCANDINAVIAN = 25;
   */
  SCANDINAVIAN = 25,
}

/**
 * Describes the enum protos.general.Ethnicity.
 */
export const EthnicitySchema: GenEnum<Ethnicity> = /*@__PURE__*/
  enumDesc(file_general_ethnicity, 0);

